<template>
    <div>
        <button v-if="!PWOI.fromHome" class="btn btn-sm btn-dark mb-1" v-on:click="back">
            <feather-icon icon="ArrowLeftIcon" class="mr-25"></feather-icon>Geri
        </button>

        <b-modal size="sm" id="create-payment-without-invoice" title="Ödeme Oluştur" no-close-on-esc no-close-on-backdrop>
            <customer-account-create-payment-without-invoice v-model="PWOI"></customer-account-create-payment-without-invoice>
            <template #modal-footer><v-executer class="ml-1" :loading="loadingWithoutInvoice" :action="createPaymentWithoutInvoice" text="Oluştur"></v-executer></template>
        </b-modal>

        <b-modal size="xl" id="payment-request" body-class="p-0" title="Ödeme Hareketleri" no-close-on-esc hide-footer no-close-on-backdrop>
            <customer-account-payment-request :code="code"></customer-account-payment-request>
        </b-modal>

        <b-modal size="sm" id="confirm-master" body-class="p-50" title="Yönetici Onay Metni" no-close-on-esc no-close-on-backdrop>
            <textarea class="form-control resize-none" v-model="confirmText" placeholder="Yönetici Onay Metni"></textarea>
            <template #modal-footer><v-executer class="ml-1" :loading="confirmLoading" :action="confirmMaster" text="Gönder"></v-executer></template>
        </b-modal>

        <div class="row" v-if="stats.CariDetail.CARI_KOD != null">
            <div class="col-md-12 mb-1">
                    <v-stats-box text="Cari Bilgisi" variant="warning" icon="business" 
                    :value="`${stats.CariDetail.CARI_KOD || '' } - ${stats.CariDetail.CARI_ISIM || '-'} - ${stats.CariDetail.CARI_ADRES|| '-' } - ${stats.CariDetail.CARI_TEL|| '-' }`" ></v-stats-box>
            </div>
        </div>
        <div class="row">
                <div class="col-md-4 mb-1">
                    <v-stats-box text="Alacak Toplam" variant="warning" icon="currency_lira" :value="stats.AlacakToplam" ></v-stats-box>
                </div>
                <div class="col-md-4 mb-1">
                    <v-stats-box text="Borç Toplam" variant="danger" icon="currency_lira" :value="stats.BorcToplam" ></v-stats-box>
                </div>
                <div class="col-md-4 mb-1">
                    <v-stats-box text="Bakiye Toplam" variant="success" icon="currency_lira" :value="stats.BakiyeToplam" ></v-stats-box>
                </div>
        </div>
        <b-card no-body>
            <v-table    ref="table"
                        :items-provider="provider"
                        pagination="server"
                        :initial-per-page="100"
                        :fields="fields">
                            <template #additional-actions>
                            <div class="row">
                                <div class="col-auto">
                                    <v-executer :action="createPaymentWithoutInvoiceModal" text="Ödeme Oluştur"></v-executer>
                                </div>
                                <div class="col-auto" >
                                    <button class="btn btn-secondary" v-on:click="$showModal('payment-request')">Ödeme Hareketleri</button>
                                </div>
                            </div>
                            </template>
                        </v-table>
        </b-card>
    </div>
</template>

<script>
import { NetsisApi } from '@/api/netsis'
import {PaymentApi} from '@/api/payment'
import { BCard } from 'bootstrap-vue'
import VStatsBox from '@/components/VStatsBox.vue'
import CustomerAccountCreatePaymentWithoutInvoice from './components/CustomerAccountCreatePaymentWithoutInvoice.vue'
import randomatic from 'randomatic'
import moment from 'moment'
import CustomerAccountPaymentRequest from './components/CustomerAccountPaymentRequest'

export default {
    components:{
        BCard,
        VStatsBox,
        CustomerAccountCreatePaymentWithoutInvoice,
        CustomerAccountPaymentRequest
    },
    data() {
        return {
            loading:false,
            loadingWithoutInvoice:false,
            code:  null,
            fields:[
                { name:"Belge No",key:'BelgeNo', tdClass:'text-nowrap',thClass:'w-6'},
                { name:"Durum",key:'PaymentPoolStatusStr',thClass:'w-6', tdClass:'text-nowrap'},
                { name:"Gör. Sayısı",key:'ClickCount',thClass:'w-6', tdClass:'text-nowrap'},
                { name:"Ref. Kodu",key:'PaymentCode',thClass:'w-7', tdClass:'text-nowrap',component:true, componentOptions:{ name:'customer/CustomerPaymentLink' }},
                { name:"Tarih",key:'Tarih',thClass:'w-6', tdClass:'text-nowrap'},
                { name:"Son Taks. Tarihi",key:'InstallmentLastDay',thClass:'w-6', tdClass:'text-nowrap'},
                { name:"Vade Tarihi",key:'VadeTarihi',thClass:'w-6', tdClass:'text-nowrap'},
                { name:"Kalan Borç (TL)",key:'KalanBorcStr', tdClass:'text-nowrap text-right',thClass:'w-7',component:true, componentOptions:{ name:'customer/CustomerDebt' }, key:'KalanBorcStr', tdClass:'text-nowrap text-right'},
                { name:"Borç (TL)",key:'BorcStr', tdClass:'text-nowrap text-right',thClass:'w-7'},
                { name:"Alacak (TL)",key:'AlacakStr',thClass:'w-7', tdClass:'text-nowrap text-right', component:true, componentOptions:{ name:'customer/CustomerCredit' }, tdClass:'text-nowrap text-right'},
                { name:"Kapatılmış Tutar (TL)",key:'KapatilmisTutarStr',thClass:'w-7', tdClass:'text-nowrap text-right'},
                { name:"Bakiye (TL)", component:true, componentOptions:{ name:'customer/CustomerBalance' }, key:'KumilatifBakiyeStr', tdClass:'text-nowrap text-right',thClass:'w-7'},
                { name:"Açıklama",key:'Aciklama',thClass:'w-6', tdClass:'text-nowrap'},
                { name:"Hareket Türü",key:'HareketTuru', tdClass:'text-nowrap',thClass:'w-16'},
            ],
            stats:{
                AlacakToplam:null,
                BorcToplam:null,
                BakiyeToplam:null,
                CariDetail:{
                    CARI_ISIM:'',
                    CARI_ADRES:'',
                    CARI_TEL:'',
                    CARI_KOD:''
                }
            },
            PWOI:{
                CustomerCode: null,
                TotalAmount: null,
                Description : null,
                CanInstallment :true,
                SendCustomer :true,
                fromHome:false
            },
            selecteds:[],
            confirmLoading:false,
            confirmText:null,
            
        }
    },
    props:{
        value:String
    },
    created(){
        this.checkCode()
    },
    methods:{
        checkCode(){
            if(this.$route.params?.code){
                this.code = this.$route.params?.code
            }else{
                this.PWOI.fromHome = true
                this.code =this.value 
            }
        },
        provider(data){
            this.getStats()
            return NetsisApi.CustomerAccountAction({
                CariCode:this.code,
                PaginationRequestModel:data
            })
        },
        clearForm(){
            this.PWOI.CustomerCode = this.code
            this.PWOI.TotalAmount = 0
            this.PWOI.Description = null
            this.PWOI.IsWithoutInvoice = true
            this.PWOI.CanInstallment = true
            this.PWOI.fromHome = this.$route.params?.code ? false : true
        },
        createPaymentWithoutInvoiceModal(){
            this.clearForm()
            this.$showModal('create-payment-without-invoice')
        },
        createPaymentWithoutInvoice(){
            this.loadingWithoutInvoice = true
            if(!this.PWOI.Tutar) this.PWOI.Tutar = 0
            PaymentApi.CreatePaymentRequest(this.PWOI).then(res => {
                this.$result(res)
                if(res.data.Success){
                    this.$hideModal('create-payment-without-invoice')
                }
                this.loadingWithoutInvoice =false
            }).catch(err=>{
                this.$result(null,err)
                this.loadingWithoutInvoice = false
            })
        },
        getStats(){
            NetsisApi.CustomerAccountActionStats(this.code).then(res=>{
                if(res.data.Success){
                    this.stats.AlacakToplam=res.data.Data.AlacakToplam
                    this.stats.BorcToplam=res.data.Data.BorcToplam
                    this.stats.BakiyeToplam=res.data.Data.BakiyeToplam
                    this.stats.CariDetail.CARI_ISIM=res.data.Data.CariDetail.CARI_ISIM
                    this.stats.CariDetail.CARI_ADRES=res.data.Data.CariDetail.CARI_ADRES
                    this.stats.CariDetail.CARI_TEL=res.data.Data.CariDetail.CARI_TEL
                    this.stats.CariDetail.CARI_KOD=res.data.Data.CariDetail.CARI_KOD
                }else{
                    this.$result(res) // Netsis sunucusundan kaynaklı olarak ara sıra verinin gelmemesi durumu için tekrar kontrol amaçlı yapılmıştır.
                }
            })
        },
        back(){
            this.$router.push({name:'customer-account'})
        },
        confirmMaster(){
            let controlData = this.selecteds.map((c) => {
                return {
                    Tutar:c.KalanBorc,
                    Tarih:c.Tarih,
                    CariCode:c.CariKod,
                    DocumentNo:c.BelgeNo,
                    VadeTarihi:c.VadeTarihi,
                    Description:this.confirmText
                }
            })
            this.confirmLoading = true
            PaymentApi.CreateResponsibleUserApproveRequest(controlData).then(res=> {
                this.$result(res)
                this.selecteds =[]
                this.$refs.table.refresh()
                this.loading =false
                this.confirmLoading = false
                this.$hideModal('confirm-master')
            }).catch(err=>{
                this.$hideModal('confirm-master')
                this.confirmLoading = false
            })

        }
    },
    computed:{
        totalSelected(){
            let sum = this.selecteds.reduce((sum,item)=>sum += item.KalanBorc,0)
            if(sum){
                return new Intl.NumberFormat('tr-TR', {
                    currency: 'TRY',
                    minimumFractionDigits: 2,
                }).format(sum)
            }else return "0,00"
        }
    }
}
</script>

<style>

</style>